var exports = {
  "n": "xe564cbfb--09ca98--link",
  "K": "xe564cbfb--09ca98--icon",
};

module.exports = exports;
